import { useNavigate } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import { Button } from '@/design-system/components/Button';
import { t } from '@/lib/i18n';
import styles from './DeniedPage.module.css';

export default function DeniedPage() {
  const navigate = useNavigate();

  return (
    <div className={styles.root}>
      <ShieldOff size={48} color="var(--color-ink-muted-48)" strokeWidth={1.5} />
      <h1 className={styles.title}>{t('denied.title')}</h1>
      <p className={styles.message}>
        {t('denied.description')}
        <br />
        {t('denied.hint')}
      </p>
      <Button variant="secondary" onClick={() => navigate('/login', { replace: true })}>
        {t('denied.backToLogin')}
      </Button>
    </div>
  );
}
